module.exports = __webpack_public_path__ + "img/ic_16_clock.3a045097.svg";